import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
  Tooltip,
  Typography,
} from '@material-ui/core'
import LocalOffer from '@material-ui/icons/LocalOfferOutlined'
import { capitalizeTitle } from '../../utils/Strings'

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    alignItems: "center",
    marginLeft: 16,
  },
  item: {
    marginLeft: 2,
    marginRight: 2,
  }
}))

const TagsHighlight = ({ tags, tags_highlight }) => {
  const classes = useStyles()

  const tagsToBeHighlighted = Object.keys(tags_highlight || {})
    .filter(tag => tag !== null)
    .map(capitalizeTitle)

  const tag_html = tags
    .filter(tag => tag !== null)
    .map(capitalizeTitle)
    .map(tag => {
      if (tagsToBeHighlighted.includes(tag)) return `<strong>${tag}</strong>`
      else return tag
    })
    .join(', ')

  return (
    <div className={classes.container}>
      <Tooltip title="Tags" aria-label="tags" className={classes.item}>
        <LocalOffer />
      </Tooltip>
      <Typography className={classes.item} dangerouslySetInnerHTML={{ __html: tag_html }} />
    </div>
  )
}

export default TagsHighlight
